<template>
  <div class="mb-30 action-panel flex items-center wrapper-x-40">
    <div
      class="action-panel__buttons"
      v-if="licensed"
    >
      <router-link
        :to="addLinkParams"
        class="btn btn-small btn-green"
      >
        <span><i class="fas fa-plus"></i></span>
        <span class="ml-2">{{ $t('main.button_add') }}</span>
      </router-link>
      <button
        class="btn btn-small btn-blue"
        @click="$emit('copyDeletes')"
      >
        <span><i class="fa fa-clone"></i></span>
        <span class="ml-2">{{ $t('main.button_copy') }}</span>
      </button>
      <button
        class="btn btn-small btn-red"
        @click="$emit('removeDeletes')"
      >
        <span><i class="fas fa-times"></i></span>
        <span class="ml-2">{{ $t('main.button_delete') }}</span>
      </button>
      <button
        class="btn btn-small btn-default"
        @click="$emit('blockDeletes')"
      >
        <span><i class="fas fa-times"></i></span>
        <span class="ml-2">{{ $t('main.button_block') }}</span>
      </button>
      <button
        class="btn btn-small btn-default"
        @click="$emit('unblockDeletes')"
      >
        <span><i class="fas fa-check"></i></span>
        <span class="ml-2">{{ $t('main.button_unblock') }}</span>
      </button>
    </div>
    <div class="action-panel__filters flex items-center ml-auto gap-3">
      <div class="form-group w-40">
        <select @change="e=>$emit('setType', e.target.value)">
          <option value="0">{{$t('main.all_types')}}</option>
          <option
            :selected="selectedType&&selectedType == type.data.type_id"
            v-for="type in types"
            :value="type.data.type_id"
            :key="`types-${type.data.type_id}`"
          >
            {{ type.data.attributes.name }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <select @change="e=>setSort(e.target.value)">
          <option
            :selected="selectedSort&&selectedSort.id == sort.id"
            v-for="sort in sorts"
            :value="sort.id"
            :key="`sorts-${sort.id}`"
          >
            {{ sort.name }}
          </option>
        </select>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "ActionPanel",
  props: {
    addLinkParams: {
      type: Object,
      default: () => {},
    },
    selectedType: {
      type: [String, Number],
      default: 0,
    },
    selectedSort: {
      type: Object,
      default: null,
    },
  },
  methods: {
    setSort(sortId) {
      const sort = this.sorts.find((s) => s.id == sortId);
      if (sort) {
        this.$emit("setSort", sortId);
      }
    },
  },
  computed: {
    licensed() {
      return this.$store.getters["licensed"];
    },
    sorts() {
      return this.$store.state.settings.sorts;
    },
    types() {
      return this.$store.state.types.allTypes;
    },
  },
};
</script>
<style scoped>
.action-panel__buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.action-panel .form-group + .form-group {
  margin-top: 0;
}
</style>
